<template>
  <div class="main">
    <heads></heads>
    <navs></navs>
    <div class="content">
      <banners></banners>
      <div class="con-main">
        <!-- 活动 -->
        <div class="con-news">
          <div class="con-news-lbt">
            <el-carousel
              :interval="5000"
              arrow="always"
              indicator-position="none"
            >
              <el-carousel-item
                v-for="(item, key) in zxzxlist"
                :key="key"
                @click="viewdetail(item.Id)"
              >
                <div class="con-news-lbt-list-main">
                  <div class="con-news-lbt-list">
                    <el-image
                      fit="cover"
                      style="width: calc(100% - 2px); height: 398px"
                      :src="`${proxy.$imgurl}${item.ThumbImage}`"
                    />
                    <div class="con-news-lbt-list-wenzi">
                      {{ item.NewsTitle }}
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="con-news-wz">
            <div
              class="con-news-wzs"
              v-for="(item, key) in zxzxlist"
              :key="key"
              @click="viewdetail(item.Id)"
            >
              <div class="con-news-wzs-title">
                <div class="con-news-wzs-title-nr">
                  {{item.NewsType===1?"【研究动态】":item.NewsType===2?"【实践动态】":item.NewsType===3?"【图片新闻】":''}}{{ item.NewsTitle }}
                </div>
                <div class="con-news-wzs-title-nr-time">
                  {{ item.NewsDate }}
                </div>
              </div>
              <div class="con-news-wzs-text">
                {{ item.NewsZy }}
              </div>
            </div>
          </div>
        </div>
        <!-- 栏目 -->
        <div class="con-lanmu">
          <div class="con-lanmu-list">
            <div class="con-lanmu-list-title">
              <div class="con-lanmu-list-title-wz">教育研究</div>
              <div
                class="con-lanmu-list-title-view"
                @click="more('/jyyj/list', 2, 1)"
              >
                更多>>
              </div>
            </div>
            <div class="con-lanmu-list-guanggao">
              <el-image
                style="width: 100%; height: 190px"
                :src="require('@/assets/img/index/lanmu-01.jpg')"
              ></el-image>
            </div>
            <div class="con-lanmu-list-wz">
              <div
                class="con-lanmu-list-wzs"
                v-for="(item, key) in lanmujyyj"
                :key="key"
                @click="tiaozhuanxiangqing(item.Id, item.type,2)"
              >
                <svg
                  t="1687765619661"
                  class="icon-lanmu"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="10740"
                  width="14"
                  height="14"
                >
                  <path
                    d="M755.2 544L390.4 874.666667c-17.066667 14.933333-44.8 14.933333-59.733333-2.133334-6.4-8.533333-10.666667-19.2-10.666667-29.866666v-661.333334c0-23.466667 19.2-42.666667 42.666667-42.666666 10.666667 0 21.333333 4.266667 27.733333 10.666666l362.666667 330.666667c17.066667 14.933333 19.2 42.666667 2.133333 59.733333 2.133333 2.133333 0 2.133333 0 4.266667z"
                    fill="#333333"
                    p-id="10741"
                  ></path>
                </svg>
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="con-lanmu-list">
            <div class="con-lanmu-list-title">
              <div class="con-lanmu-list-title-wz">科技探索</div>
              <div
                class="con-lanmu-list-title-view"
                @click="more('/kjts/list', 3, 2)"
              >
                更多>>
              </div>
            </div>
            <div class="con-lanmu-list-guanggao">
              <el-image
                style="width: 100%; height: 190px"
                :src="require('@/assets/img/index/lanmu-02.jpg')"
              ></el-image>
            </div>
            <div class="con-lanmu-list-wz">
              <div
                class="con-lanmu-list-wzs"
                v-for="(item, key) in lanmukjts"
                :key="key"
                @click="tiaozhuanxiangqing(item.Id, item.type,3)"
              >
                <svg
                  t="1687765619661"
                  class="icon-lanmu"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="10740"
                  width="14"
                  height="14"
                >
                  <path
                    d="M755.2 544L390.4 874.666667c-17.066667 14.933333-44.8 14.933333-59.733333-2.133334-6.4-8.533333-10.666667-19.2-10.666667-29.866666v-661.333334c0-23.466667 19.2-42.666667 42.666667-42.666666 10.666667 0 21.333333 4.266667 27.733333 10.666666l362.666667 330.666667c17.066667 14.933333 19.2 42.666667 2.133333 59.733333 2.133333 2.133333 0 2.133333 0 4.266667z"
                    fill="#333333"
                    p-id="10741"
                  ></path>
                </svg>
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="con-lanmu-list">
            <div class="con-lanmu-list-title">
              <div class="con-lanmu-list-title-wz">健康科普</div>
              <div
                class="con-lanmu-list-title-view"
                @click="more('/jkkp/list', 4, 3)"
              >
                更多>>
              </div>
            </div>
            <div class="con-lanmu-list-guanggao">
              <el-image
                style="width: 100%; height: 190px"
                :src="require('@/assets/img/index/lanmu-03.jpg')"
              ></el-image>
            </div>
            <div class="con-lanmu-list-wz">
              <div
                class="con-lanmu-list-wzs"
                v-for="(item, key) in lanmujkkp"
                :key="key"
                @click="tiaozhuanxiangqing(item.Id, item.type,4)"
              >
                <svg
                  t="1687765619661"
                  class="icon-lanmu"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="10740"
                  width="14"
                  height="14"
                >
                  <path
                    d="M755.2 544L390.4 874.666667c-17.066667 14.933333-44.8 14.933333-59.733333-2.133334-6.4-8.533333-10.666667-19.2-10.666667-29.866666v-661.333334c0-23.466667 19.2-42.666667 42.666667-42.666666 10.666667 0 21.333333 4.266667 27.733333 10.666666l362.666667 330.666667c17.066667 14.933333 19.2 42.666667 2.133333 59.733333 2.133333 2.133333 0 2.133333 0 4.266667z"
                    fill="#333333"
                    p-id="10741"
                  ></path>
                </svg>
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <!-- 栏目  暂无内容  隐藏 -->
        <div class="con-lanmu" v-if="false">
          <div class="con-lanmu-list">
            <div class="con-lanmu-list-title">
              <div class="con-lanmu-list-title-wz">思政一体</div>
              <div class="con-lanmu-list-title-view">更多>></div>
            </div>
            <div class="con-lanmu-list-guanggao">
              <el-image
                style="width: 100%; height: 190px"
                :src="require('@/assets/img/index/lanmu-04.jpg')"
              ></el-image>
            </div>
            <div class="con-lanmu-list-wz">
              <div class="con-lanmu-list-wzs" v-for="item in 5" :key="item">
                <svg
                  t="1687765619661"
                  class="icon-lanmu"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="10740"
                  width="14"
                  height="14"
                >
                  <path
                    d="M755.2 544L390.4 874.666667c-17.066667 14.933333-44.8 14.933333-59.733333-2.133334-6.4-8.533333-10.666667-19.2-10.666667-29.866666v-661.333334c0-23.466667 19.2-42.666667 42.666667-42.666666 10.666667 0 21.333333 4.266667 27.733333 10.666666l362.666667 330.666667c17.066667 14.933333 19.2 42.666667 2.133333 59.733333 2.133333 2.133333 0 2.133333 0 4.266667z"
                    fill="#333333"
                    p-id="10741"
                  ></path>
                </svg>
                {{ nullinfo }}
              </div>
            </div>
          </div>
          <div class="con-lanmu-list">
            <div class="con-lanmu-list-title">
              <div class="con-lanmu-list-title-wz">美育融合</div>
              <div class="con-lanmu-list-title-view">更多>></div>
            </div>
            <div class="con-lanmu-list-guanggao">
              <el-image
                style="width: 100%; height: 190px"
                :src="require('@/assets/img/index/lanmu-05.jpg')"
              ></el-image>
            </div>
            <div class="con-lanmu-list-wz">
              <div class="con-lanmu-list-wzs" v-for="item in 5" :key="item">
                <svg
                  t="1687765619661"
                  class="icon-lanmu"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="10740"
                  width="14"
                  height="14"
                >
                  <path
                    d="M755.2 544L390.4 874.666667c-17.066667 14.933333-44.8 14.933333-59.733333-2.133334-6.4-8.533333-10.666667-19.2-10.666667-29.866666v-661.333334c0-23.466667 19.2-42.666667 42.666667-42.666666 10.666667 0 21.333333 4.266667 27.733333 10.666666l362.666667 330.666667c17.066667 14.933333 19.2 42.666667 2.133333 59.733333 2.133333 2.133333 0 2.133333 0 4.266667z"
                    fill="#333333"
                    p-id="10741"
                  ></path>
                </svg>
                {{ nullinfo }}
              </div>
            </div>
          </div>
          <div class="con-lanmu-list">
            <div class="con-lanmu-list-title">
              <div class="con-lanmu-list-title-wz">心理聚焦</div>
              <div class="con-lanmu-list-title-view">更多>></div>
            </div>
            <div class="con-lanmu-list-guanggao">
              <el-image
                style="width: 100%; height: 190px"
                :src="require('@/assets/img/index/lanmu-06.jpg')"
              ></el-image>
            </div>
            <div class="con-lanmu-list-wz">
              <div class="con-lanmu-list-wzs" v-for="item in 5" :key="item">
                <svg
                  t="1687765619661"
                  class="icon-lanmu"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="10740"
                  width="14"
                  height="14"
                >
                  <path
                    d="M755.2 544L390.4 874.666667c-17.066667 14.933333-44.8 14.933333-59.733333-2.133334-6.4-8.533333-10.666667-19.2-10.666667-29.866666v-661.333334c0-23.466667 19.2-42.666667 42.666667-42.666666 10.666667 0 21.333333 4.266667 27.733333 10.666666l362.666667 330.666667c17.066667 14.933333 19.2 42.666667 2.133333 59.733333 2.133333 2.133333 0 2.133333 0 4.266667z"
                    fill="#333333"
                    p-id="10741"
                  ></path>
                </svg>
                {{ nullinfo }}
              </div>
            </div>
          </div>
        </div>
        <!-- 成果矩阵 -->
        <div class="con-cgjz">
          <div class="con-cgjz-title"><span>NEWSPAPER MATRIX</span>报刊矩阵</div>
          <div class="con-cgjz-gd">
            <el-carousel :interval="4000" type="card" height="210px">
              <el-carousel-item v-for="(item, key) in cgjzlist" :key="key">
                <div class="con-cgjz-list">
                  <div
                    class="con-cgjz-list-img"
                    @click="cgjzclick(e)"
                    v-for="(e, i) in item"
                    :key="i"
                  >
                    <el-image
                      style="width: 163px; height: 208px"
                      :src="require('@/assets/img/index/' + e.imgurl)"
                    ></el-image>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <!-- 专家支持 -->
      <div class="con-zjzc">
        <div class="con-zjzc-title">
          <div class="con-zjzc-title-main">专家支持</div>
          <div class="con-zjzc-title-sub">EXPERT SUPPORT</div>
        </div>
        <div class="con-zjzc-gd">
          <el-carousel indicator-position="outside" height="500px">
            <el-carousel-item v-for="(item, key) in zjlistall" :key="key">
              <div class="con-zjzc-gd-lsit">
                <div
                  class="con-zjzc-gd-lsit-item"
                  v-for="(e, i) in item"
                  :key="i"
                  @click="ckzj(e)"
                >
                  <div class="con-zjzc-gd-lsit-item-toux">
                    <el-avatar :size="150" :src="`${proxy.$imgurl}${e.exfm}`" />
                  </div>
                  <div class="con-zjzc-gd-lsit-item-js">
                    <div class="con-zjzc-gd-lsit-item-js-title">
                      {{ e.exname }}
                    </div>
                    <div class="con-zjzc-gd-lsit-item-js-con">
                      {{ e.jianjie }}
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="con-main">
        <div class="con-szb">
          <div class="con-szb-title">
            <el-image
              style="width: 268px; height: 57px"
              :src="require('@/assets/img/index/szb.jpg')"
            ></el-image>
          </div>
          <div class="con-szb-nr">
            <div
              class="con-szb-nrs"
              v-for="(item, key) in bminfolist"
              :key="key"
              @click="viewxq(item)"
            >
              <el-image
                class="con-szb-nrs-img"
                :src="`${proxy.$imgurl}${item.bmurl}`"
              ></el-image>
              <div class="con-szb-nrs-wz">
                {{ item.bmname==""?"第"+ item.bm + "版":"第"+ item.bm + "版："+item.bmname }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script setup>
import { get } from "@/utils/index";
import { reactive, getCurrentInstance, ref } from "vue";
const { proxy } = getCurrentInstance();
// router
import { useRouter } from "vue-router";
const router = useRouter();
// vuex
import { useStore } from "vuex";
const store = useStore();

// 当前期数索引
let dqqsindex = ref(0);
// 类型
let contype = store.state.contype;
// 获取新闻的类型
let newsType=ref(4)
// 全部期数
let allqishuList = reactive([]);
// 本期详情
let bqxqobj = reactive({});
// 版面信息
let bminfolist = reactive([]);
// 当前报纸id
let baozhiId = ref("");
// 教研成果数据
let jycgall = reactive([]);
// 最新资讯列表
let zxzxlist = reactive([]);
// 专家队伍
let zjlistall = reactive([]);
// 无信息
let nullinfo = ref("");
// 成果举证
let cgjzlist = reactive([
  [
    {
      imgurl: "cgjz-1.jpg",
      link: "/jyyj/list",
      idx: 2,
      dflid: 1,
    },
    {
      imgurl: "cgjz-2.jpg",
      link: "/kjts/list",
      idx: 3,
      dflid: 2,
    },
  ],
  [
    {
      imgurl: "cgjz-3.jpg",
      link: "/kjts/list",
      idx: 3,
      dflid: 2,
    },
    {
      imgurl: "cgjz-4.jpg",
      link: "/jkkp/list",
      idx: 4,
      dflid: 3,
    },
  ],
  [
    {
      imgurl: "cgjz-5.jpg",
      link: "/szyt/list",
      idx: 5,
      dflid: 4,
    },
    {
      imgurl: "cgjz-6.jpg",
      link: "/xljj/list",
      idx: 7,
      dflid: 6,
    },
  ],
  [
    {
      imgurl: "cgjz-7.jpg",
      link: "/xxfz/list",
      idx: 8,
      dflid: 7,
    },
    {
      imgurl: "cgjz-8.jpg",
      link: "/xxfz/list",
      idx: 8,
      dflid: 7,
    },
  ],
]);
// 栏目的列表
let lanmujkkp = reactive([]);
let lanmujyyj = reactive([]);
let lanmukjts = reactive([]);
let lanmuszyt = reactive([]);
let lanmumyrh = reactive([]);
let lanmuxljj = reactive([]);

// 获取最新资讯
const getzxzx = () => {
  get("/api/NewsPaper/GetNewsList", {
    PageSize: 3,
    PageIndex: 1,
    Sort: "NewsSort",
    NewsType: newsType.value,
  }).then((res) => {
    // console.log(res);
    zxzxlist.push(...res.Data);
  });
};
getzxzx();

// 查看资讯
const viewdetail = (id) => {
  router.push({
    path: "/hdzq/detail",
    query: {
      idx:1,
      id: id,
    },
  });
};

// 获取全部期数
const getqsall = () => {
  get("/api/NewsPaper/GetAllNewsPaper").then((res) => {
    baozhiId.value = res.data.filter((e) => {
      return e.nptitle === "健康人报";
    })[0].Id;
    get("/api/NewsPaper/GetAllQishu", {
      type: contype.filter((e) => {
        return e.name === "报纸";
      })[0].value,
      id: baozhiId.value,
    }).then((res) => {
      // 保存全部期数
      allqishuList.push(...res.data);
      // 获取最新一期内容
      getbqxq(allqishuList[dqqsindex.value].Id);
    });
  });
};
getqsall();

// 获取本期详情
const getbqxq = (qsid) => {
  get("/api/NewsPaper/GetQishuDet", {
    id: qsid,
  }).then((res) => {
    Object.assign(bqxqobj, res.data);
    bminfolist.push(...JSON.parse(bqxqobj.bmjson));
    // console.log(bminfolist)
  });
};

// 点击期数
const viewxq = (data) => {
  window.open('http://jkrb.ktnw.cn/')



  //健康人报 不显示期数 20231010
  // console.log(router.currentRoute.value.query.navid)
  router.push({
    path: "/jkkp/index",
    query: {
      idx: 4,
      id: allqishuList[0].Id, //最新一期id
      bzid: "593840512721489920", //报纸id  用于获取全部期数
      navid: 3, //大分类id
      bmidx: data.bm,
    },
  });
};

// 获取教育研究新闻
const getkyyjxw = () => {
  get("/api/NewsPaper/GetBsQmart", {
    type: contype.filter((e) => {
      return e.name === "期刊";
    })[0].value,
    id: "599202639854440448", //大学
    top: 5,
  }).then((res) => {
    res.data.forEach((e) => {
      e.type = contype.filter((e) => {
        return e.name === "期刊";
      })[0].value;
    });
    lanmujyyj.push(...res.data);
  });
};
getkyyjxw();

// 获取科技探索新闻
const getkltsxw = () => {
  get("/api/NewsPaper/GetBsQmart", {
    type: contype.filter((e) => {
      return e.name === "期刊";
    })[0].value,
    id: "599274085066739712", //科技成果与传播
    top: 5,
  }).then((res) => {
    res.data.forEach((e) => {
      e.type = contype.filter((e) => {
        return e.name === "期刊";
      })[0].value;
    });
    lanmukjts.push(...res.data);
  });
};
getkltsxw();

// 获取健康科普新闻
const getjkkpxw = () => {
  get("/api/NewsPaper/GetBsQmart", {
    type: contype.filter((e) => {
      return e.name === "报纸";
    })[0].value,
    id: "593840512721489920", //健康人报
    top: 5,
  }).then((res) => {
    res.data.forEach((e) => {
      e.type = contype.filter((e) => {
        return e.name === "报纸";
      })[0].value;
    });
    lanmujkkp.push(...res.data);
    // console.log(lanmujkkp);
  });
};
getjkkpxw();

// 点击咨询跳转详情
const tiaozhuanxiangqing = (wzid, type,idx) => {
  let path = "";
  switch (type) {
    case 1:
      path = "/jkkp/wzxq";
      break;
    case 2:
      path = "/jyyj/wzxq";
      break;
  }
  router.push({
    path: path,
    query: {
      wzid: wzid, //文章id
      idx:idx
    },
  });
};

// 更多
const more = (path, idx, dflid) => {
  router.push({
    path: path,
    query: {
      idx: idx,
      dflid: dflid, //大分类id
    },
  });
};

// 专家队伍
const group = (array, subGroupLength) => {
  //拆分数组  array原数组  subGroupLength新数组长度
  let index = 0;
  let newArray = [];
  while (index < array.length) {
    newArray.push(array.slice(index, (index += subGroupLength)));
  }
  return newArray;
};
const getzjdw = () => {
  get("/api/NewsPaper/GetExpertList", {
    PageIndex: 1,
    PageSize: 12,
  }).then((res) => {
    zjlistall.push(...group(res.Data, 4));
  });
};
getzjdw();
// 查看专家队伍
const ckzj = (data) => {
  // console.log(data);
  router.push({
    path: "/zjdw/detail",
    query: {
      id: data.Id,
      idx:9
    },
  });
};

// 查看成果举证
const cgjzclick = (data) => {
  // console.log(data.link)
  router.push({
    path: data.link,
    query: {
      idx: data.idx,
      dflid: data.dflid,
    },
  });
};
</script>

<style scoped>
::v-deep .el-carousel__container {
  height: 400px;
}
.main {
  background: #fff;
}
.con-main {
  width: 1200px;
  margin: auto;
}
.con-news {
  padding: 30px 0;
}
.con-news:after {
  content: "";
  display: table;
  clear: both;
}
.con-news-lbt {
  float: left;
  width: 50%;
  height: 400px;
}
.con-news-lbt-list-main {
  position: relative;
  width: 100%;
  height: 400px;
}
.con-news-lbt-list-wenzi {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
}
.con-news-lbt-list {
  width: 100%;
  height: 400px;
}
.con-news-wz {
  float: right;
  width: 50%;
  height: 400px;
  box-sizing: border-box;
  padding-left: 30px;
}
.con-news-wzs {
  margin-bottom: 46px;
}
.con-news-wzs-title {
  padding-bottom: 10px;
}
.con-news-wzs-title:after {
  content: "";
  display: table;
  clear: both;
}
.con-news-wzs-title-nr {
  float: left;
  font-weight: bold;
  cursor: pointer;
  width: 400px;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
.con-news-wzs-title-nr:hover {
  color: #2fadc6;
}
.con-news-wzs-text:hover {
  color: #2fadc6;
}
.con-news-wzs-title-nr-time {
  float: right;
  font-size: 14px;
  color: #999;
}
.con-news-wzs-text {
  font-size: 14px;
  text-align: justify;
  line-height: 24px;
  cursor: pointer;
  height: 72px;
  overflow: hidden;
}
.con-guanggao {
  margin-bottom: 20px;
}
.con-lanmu {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.con-lanmu-list {
  width: 32%;
  height: auto;
}
.con-lanmu-list-title {
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.con-lanmu-list-title-wz {
  font-size: 18px;
  font-weight: bold;
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  border-bottom: 2px solid #2fadc6;
}
.con-lanmu-list-title-view {
  font-weight: 100;
  font-size: 14px;
  cursor: pointer;
}
.con-lanmu-list-title-view:hover {
  color: #2fadc6;
}
.con-lanmu-list-title-view a:link,
.con-lanmu-list-title-view a:visited {
  color: #2c3e50;
  text-decoration: none;
}
.icon-lanmu {
  float: left;
  margin: 3px 5px 0 0;
}
.con-lanmu-list-wzs {
  height: 20px;
  line-height: 20px;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
  cursor: pointer;
  margin: 15px 0;
}
.con-lanmu-list-wzs:hover {
  color: #2fadc6;
}
.con-xgg {
  display: flex;
  justify-content: space-between;
}
.con-xgg-list {
  width: 585px;
  margin-bottom: 30px;
}
.con-szb {
  margin: 0 0 50px 0;
}
.con-szb-title {
  width: 100%;
  height: 57px;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
}
.con-szb-nrs-wz {
  text-align: center;
  font-size: 14px;
  padding-top: 5px;
  cursor: pointer;
}
.con-szb-nrs {
  width: 180px;
  margin-right: 20px;
}
.con-szb-nr {
  box-sizing: border-box;
  width: 100%;
  background: #f4f4f4;
  padding: 20px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  margin-top: 30px;
}
.con-szb-nr:after {
  content: "";
  display: table;
  clear: both;
}
.con-szb-nrs-img {
  width: 180px;
  height: 260px;
  cursor: pointer;
}
.con-szb-nrs-wz:hover {
  color: #2fadc6;
}
.con-links {
  box-sizing: border-box;
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  margin: 30px 0 50px 0;
}
.con-links-title {
  width: 100px;
  height: 50px;
  line-height: 50px;
  border-top: 2px solid #2fadc6;
  font-size: 18px;
  text-align: center;
  color: #2fadc6;
}
.con-links-nr {
  width: calc(100% - 100px);
}
.con-links-nr:after {
  content: "";
  display: table;
  clear: both;
}
.con-links-nrs {
  float: left;
  height: 50px;
  line-height: 55px;
  margin: 0 20px;
}
.con-cgjz {
  margin-bottom: 50px;
}
.con-cgjz-title {
  position: relative;
  width: 300px;
  height: 50px;
  margin: auto;
  display: flex;
  font-size: 24px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #ccc;
  margin-bottom: 30px;
}
.con-cgjz-title:after {
  content: "";
  position: absolute;
  left: calc(50% - 12px);
  bottom: -1px;
  width: 24px;
  height: 2px;
  background: #f00;
}
.con-cgjz-title > span {
  color: #f00;
  font-weight: bold;
  font-size: 16px;
  height: 100%;
  display: block;
  line-height: 58px;
  margin-right: 10px;
}
.con-cgjz-gd {
  width: 100%;
  height: 210px;
  /* background: #F4F4F4;
  padding: 20px 0; */
}
.con-cgjz-list {
  width: 100%;
  height: 210px;
  display: flex;
  justify-content: center;
}
.con-cgjz-list-img {
  width: 163px;
  height: 208px;
  margin: 0 10px;
  border: 1px solid #ccc;
}
.con-zjzc {
  width: 100%;
  padding: 30px 0;
  background: #f2fafd;
  margin-bottom: 50px;
}
.con-zjzc-title {
  padding-bottom: 30px;
}
.con-zjzc-title-main {
  font-size: 24px;
  text-align: center;
  padding-bottom: 10px;
}
.con-zjzc-title-sub {
  color: #999;
  font-size: 16px;
  text-align: center;
}
.con-zjzc-gd {
  width: 1200px;
  height: auto;
  margin: auto;
}
.con-zjzc-gd-lsit {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  flex-wrap: wrap;
}
.con-zjzc-gd-lsit-item {
  width: 590px;
  height: 240px;
  box-sizing: border-box;
  padding: 30px;
  background: #fff;
  cursor: pointer;
}
.con-zjzc-gd-lsit-item-toux {
  width: 150px;
  height: 100%;
  float: left;
  display: flex;
  align-items: center;
}
.con-zjzc-gd-lsit-item-js {
  width: 350px;
  float: right;
  height: 100%;
}
.con-zjzc-gd-lsit-item-js-title {
  font-weight: bold;
  padding-bottom: 10px;
}
.con-zjzc-gd-lsit-item-js-con {
  text-align: justify;
  font-size: 14px;
  height: 153px;
  overflow: hidden;
  line-height: 26px;
}
</style>
